<template>
  <div class="dashboard">
    <div style="position: relative;">
      <img src="../images/landingpage.jpg">
      <div id="blob" class="card-band-styling">
        <p id="title">
          NeuroLeap Cloud
        </p>
        <p style="margin: 0;">
          NeuroLeap enables children with potential disabilities/impairements via healthcare organizations, 
          to receive a higher quality assessment and intervention regarding cognitive skills (IQ), mental 
          health (EQ) and motor skills. We also provide the optimal tools for schools to satisfy their legal 
          obligation in identifying and educating children with learning disabilities (LD), including dyslexia, 
          and speech & language impairment (SLI).
        </p>
      </div>  
    </div>
  </div>
</template>

<script>
  export default {
    name: "LandingMain"
  };
</script>

<style scoped lang="scss">
  @use 'sharedSCSS/globalSharedVariables';

  .dashboard {
    width: 100%;
    position: relative;
  }

  img {
    width: 100%;
    height: 35vw;
    object-fit: cover;
  }

  #blob {
    position: absolute;
    border-radius: 1rem;
    left: 2rem;
    bottom: -3rem;
    width: clamp(150px, 50vw, 700px);
    padding: .5rem;
    font-family: 'Roboto', sans-serif;
    margin: 0;
  }

  #title {
    font-size: clamp(1rem, 2vw, 1.5rem);
    font-weight: bold;
    margin: 0;
  }

  p {
    font-size: clamp(.5rem, 1vw, 1rem);
    margin: 0;
  }
</style>